import { Edge, Node } from 'reactflow'

export const getParent = (closestNode: Node | null, nodes: Node[], edges: Edge[]): Node | null => {
  if (!closestNode) return null

  const upEdge = edges.find((e: Edge) => e.target === closestNode.id)

  if (!upEdge) return null

  const parent = nodes.find((n) => n.id === upEdge.source)

  // so we can return null instead of returning undefined
  if (!parent) return null
  else return parent
}
